import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, of, ReplaySubject } from 'rxjs';
import { ClaimDetailsItem } from 'src/app/model/claimdetails';
import { DocumentItem } from 'src/app/model/document-item';
import { Question } from 'src/app/model/question-item';
import {AnswerOption2, MultipleOption, Answer} from 'src/app/model/question-item';
import { QuestionSetItem } from 'src/app/model/questionset-item';
import { ShippingItem } from 'src/app/model/shipping-item';
import { CommonService } from 'src/app/services/common.service';
import { MSSPService } from 'src/app/services/mssp.service';
import { StorageService } from 'src/app/services/storage.service';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-service-validation',
  templateUrl: './service-validation.component.html',
  styleUrls: ['./service-validation.component.scss']
})
export class ServiceValidationComponent implements AfterViewChecked {
  @Output() serviceValidationForm:EventEmitter<FormGroup> = new EventEmitter();
  @Output() serviceValidationStepBack:EventEmitter<boolean> = new EventEmitter();
  @Input() questionSetItem!:QuestionSetItem;
  @Input() serviceDataForm!:FormGroup;

  faUpload = faUpload

  days:number[] = []
  months:number[] = []
  years:number[] = []
  today:Date = new Date()
  startDate!:Date
  endDate!:Date 
  document:boolean = false
  isDisabled:boolean = false
  isDisabledBack:boolean= false
  file: File | null = null
  certificate!:string
  loading:boolean = false
  sendDocument = false

  isDocumentDisabled:boolean = false

  formGroup!:FormGroup
  
  constructor(
    public commonService:CommonService,
    private fb: FormBuilder,
    private msspService:MSSPService,
    private router:Router,
    private cdref:ChangeDetectorRef
  ) { 
    this.certificate = this.commonService.certificate
    var todayYear = this.today.getFullYear();
    this.years = Array(todayYear-2018).fill(1).map((x, i) => todayYear - i)
    this.days = Array(31).fill(1).map((x,i)=>i+1)
    this.months = Array(12).fill(1).map((x,i)=>i+1)

    this.formGroup = this.fb.group({
      questions: this.fb.array([[this.createQuestion(null,null,null,null)], Validators.required])
    })  
  }

  
  stepBack(){
    this.serviceValidationStepBack.emit(true)
  }

  stepOn() {
    if(this.document && !this.file)
      alert('Es necesario cargar el documento para poder continuar')
      
    if (this.document && this.file) {
      this.loading = true;
      this.convertFile(this.file).subscribe(base64 => {
        if (base64) {
          var documentItem = new DocumentItem(
            this.commonService.idCliente,
            this.commonService.certificate,
            "CARGA INICIAL DOCUMENTO CLAIM",
            this.file?.type as string,
            this.file?.name as string,
            base64,
            "LVPLSPPMXP"
          )
          this.msspService.attachDocument(documentItem).subscribe((resDocument) => {
            if(resDocument){
              this.sendDocument = true;
              this.sendData()
            }
          })
        }
      })

    }else{
      this.sendData()
    }
  }

  sendData(){
    if ((!this.document && this.serviceDataForm) || (this.document && this.file && this.serviceDataForm && this.sendDocument)) {
      var arrayAns = this.questions.controls
      var day = this.serviceDataForm.get('day')
      var month = this.serviceDataForm.get('month')
      var year = this.serviceDataForm.get('year')
      var description = this.serviceDataForm.get('description')
      var date = new Date(year?.value, month?.value - 1, day?.value, 0, 0, 0, 0)
      this.questionSetItem.IdCliente = this.commonService.idCliente;
      this.questionSetItem.Certificate = this.certificate
      this.questionSetItem.Questions.forEach((res, index) => {
        if (res.AnswerType == '1' || res.AnswerType == '2' || res.AnswerType == '3') {
          var monthFormat = date.getMonth()+1 < 10 ?  '0' + (date.getMonth() +1) : date.getMonth()+1
          var dayFormat =  date.getDate() < 10 ?  '0' + (date.getDate()) : date.getDate()
          var dateFormat = dayFormat + "/" + monthFormat + "/" + date.getFullYear()
          
          if (index == 0) res.Answer.Answer = dateFormat
          if (index == 1) res.Answer.Answer = description?.value
          if (index == 2) res.Answer.Answer = this.commonService.phone
          if (index >= 3) {
            var b = arrayAns[index].get('text')?.value
            var a = this.questionSetItem.Questions.find(res => res.Text == b)?.Answer as AnswerOption2
            var c = a.Answers.find(res => res.Text == arrayAns[index].get('multiple')?.value)

            if (c?.Code) {
              var questionAnswer = arrayAns[index].get('multiple')?.value
              var sequenceResponse = 0
              if (questionAnswer == "Yes") {
                sequenceResponse = 1
              } else if (questionAnswer == 'No') {
                sequenceResponse = 2
              }
              res.Answer.Answer = new MultipleOption(c?.Code, questionAnswer, sequenceResponse)
            }
          }
        }
      })
      this.isDisabled = true;
      this.isDisabledBack = true;
      this.loading = true;
      this.msspService.submitQuestionSet(this.questionSetItem).subscribe((resQuestion) => {
        if (resQuestion.data) {
          this.commonService.addressForm
          var street = this.commonService.addressForm.get('street')
          var externalNumber = this.commonService.addressForm.get('externalNumber')
          var internalNumber = this.commonService.addressForm.get('internalNumber')
          var neighborhood = this.commonService.addressForm.get('neighborhood')
          var postalCode = this.commonService.addressForm.get('postalCode')
          var mayoralty = this.commonService.addressForm.get('mayoralty')
          var state = this.commonService.addressForm.get('state')
          var firstName = this.commonService.personalForm.get('name')
          var lasName = this.commonService.personalForm.get('lastName')
          var secondLastName = this.commonService.personalForm.get('secondLastName')
          var email = this.commonService.personalForm.get('email')
          var phone = this.commonService.personalForm.get('phone')
          var sessionId = sessionStorage.getItem("sessionId") || "";

          if (street && externalNumber && internalNumber && neighborhood && postalCode && mayoralty && state) {
            var shipping = new ShippingItem(
              this.commonService.idCliente,
              this.commonService.caseNumber,
              this.commonService.interactionNumber,
              street?.value + " " + externalNumber?.value + " " + internalNumber?.value,
              neighborhood?.value,
              state?.value,
              mayoralty?.value,
              state?.value,
              "MX",
              postalCode?.value,
              firstName?.value,
              lasName?.value + " " + secondLastName?.value,
              email?.value,
              phone?.value,
              this.commonService.session || sessionId,
              this.commonService.dealerCode,
              this.commonService.companyCode
            )
            this.msspService.submitShipping(shipping).subscribe((res) => {
              if (res.data) {
                var status = this.getDecisionType(resQuestion.data.DecisionType)
                if (status && (status == 'Aprobada' || status == 'Pendiente'  || status == 'Aceptada')) {
                  this.router.navigate([`/success/${resQuestion.data.ClaimNumber}/${status}`])
                } else if (resQuestion.data.ClaimNumber) {

                  var claimDetail = new ClaimDetailsItem(
                    this.commonService.idCliente,
                    resQuestion.data.ClaimNumber,
                    this.commonService.dealerCode,
                    this.commonService.companyCode
                  )
                  this.msspService.getClaimDetails(claimDetail).subscribe((resClaimDetail) => {
                    if (resClaimDetail.data) {
                      if (resClaimDetail.data.ClaimStatus == 'P' || resClaimDetail.data.ClaimStatus == 'A') {
                        var status = this.getDecisionTypeClaim(resClaimDetail.data.ClaimStatus)
                        this.router.navigate([`/success/${resQuestion.data.ClaimNumber}/${status}`])
                      } else {
                        this.router.navigate([`/failed`])
                      }
                    }
                  })
                } else {
                  this.router.navigate([`/failed`])
                }
              }

            })
          }

        }
      })
    }
  }


  ngAfterViewChecked() {
    let dis = this.isDisabled;
    if (dis != this.isDisabled) { // check if it change, tell CD update view
      this.isDisabled = dis;
      this.cdref.detectChanges();
    }
  }

  get questions():FormArray{
    return <FormArray> this.formGroup.get('questions')
  }

  addQuestion(question:Question){
    if(question.SequenceNumber == '1'){
      this.clearFormArray(this.questions)
    } 
    if(question.PreConditions){
      if(question?.PreConditions?.length > 0 ){
        var quesCode = question?.PreConditions[0].QuestionCode
        var ansCode  = question?.PreConditions[0].AnswerCode

        var index = this.questionSetItem.Questions.find(res => res.Code == quesCode)
        var ansCast = index?.Answer as AnswerOption2
        var valueRes = ansCast.Answers.find(res => res.Code == ansCode)
        this.questions.push(this.createQuestion(Number(question.AnswerType), question.Text, Number(index?.SequenceNumber)-1, valueRes?.Text));
        console.log(this.questions)
        return 
    }

    }
    this.questions.push(this.createQuestion(Number(question.AnswerType), question.Text, null, null));

    console.log(this.questions);
    
  }

  createQuestion(questionType:number | null, textField:string | null, index:number | null, value:string | null | undefined):FormGroup{
    switch(questionType){
      case 1:
        return this.fb.group({
          type:[questionType],
          text:[textField],
          day: [''],
          month: [''],
          year: [''],
        }, {
          validators: this.validateDate
        })
      case 2:
        return this.fb.group({
          type:[questionType],
          text:[textField],
          description: [''],
        })
      case 3:
        return this.fb.group({
          index:[index],
          value:[value],
          type:[questionType],
          text:[textField],
          multiple: [''],
        })
      default:
        return this.fb.group({
          description:[null],
        })
    } 
  
  }

  clearFormArray(formArray: FormArray){
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  validateDate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const day = control.get('day');
    const month = control.get('month')
    const year = control.get('year')

    const todayDay = this.today.getDate()
    const todayMonth = this.today.getMonth()+1
    const todayYear = this.today.getFullYear()

    if((year && year.value == todayYear && month && month.value > todayMonth)){
      control.get('month')?.setValue(todayMonth)
    }else if ((year && year.value == todayYear && month && month.value == todayMonth && day && day.value > todayDay)){
      control.get('day')?.setValue(todayDay)
    }
    return null
  };

  isDocument(res:boolean){
    this.document = res
  }

  readFile(fileEvent: any) {
    const file = fileEvent.target.files[0];
    if ((file.size / 1000000) >= 10 || (file.type != "image/png" && 
        file.type != "image/jpg" && 
        file.type != "image/jpeg" && 
        file.type != "application/pdf")){
      return
    }
    this.file = file
  }

  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      if(event?.target?.result)
      result.next(btoa(event.target.result.toString()))
    };
    return result;
  }

  getDecisionType(type:any){
    //Denied, Approved, Pending, Refer, Retained, Accepted
    var decision:any = {
      0:"Rechazada",
      1:"Aprobada",
      2:"Pendiente",
      3:"Referida",
      4:"Retenida",
      5:"Aceptada"
    }
    return decision[type]
  }

  getDecisionTypeClaim(type:any){
    var decision:any = {
      'P':"Pendiente",
      'A':"Aprobada",
      'D':"Rechazada",
      'C':"Cerrada"
    }
    return decision[type]
  }

  validateProductAssurance(): boolean {
    if (this.serviceDataForm) {
      var day = this.serviceDataForm.get('day')
      var month = this.serviceDataForm.get('month')
      var year = this.serviceDataForm.get('year')
      var claimDate = new Date(year?.value, month?.value - 1, day?.value, 0, 0, 0, 0)
      if (claimDate > this.commonService.productDate  && claimDate < this.commonService.startDate){
        return true
      }
    }
    return false
  }
}
